import { makeStyles } from '@material-ui/styles'
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({
    contentDiv: {
      width: "100%"
    },
    icon: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        '& .MuiSvgIcon-root': {
            marginRight: 5,
        },
    },
    stepCompleted: {
        root : {
            color: 'green'
        }
    },
    layoutContainer: {
      height: 200,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: theme.spacing(2),
      border: "1px dashed",
      borderColor: theme.palette.primary.main,
      position: "relative"
    },
    layoutText: {
      color: tinycolor(theme.palette.background.light)
        .darken()
        .toHexString()
    },
    layoutButtonsRow: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    },
    layoutButton: {
      backgroundColor: theme.palette.background.light,
      width: 125,
      height: 50,
      outline: "none",
      border: "none"
    },
    layoutButtonActive: {
      backgroundColor: tinycolor(theme.palette.background.light)
        .darken()
        .toHexString()
    },
    buttonsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      marginTop: theme.spacing(2)
    },
    notificationCallButton: {
      color: "white",
      marginBottom: theme.spacing(1),
      textTransform: "none"
    },
    codeContainer: {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(2)
    },
    codeComponent: {
      flexGrow: 1
    },
    notificationItem: {
      marginTop: theme.spacing(2)
    },
    notificationCloseButton: {
      position: "absolute",
      right: theme.spacing(2)
    },
    toastsContainer: {
      width: "auto",
      marginTop: theme.spacing(6),
      right: 0
    },
    progress: {
      visibility: "hidden"
    },
    notification: {
      display: "flex",
      alignItems: "center",
      background: "transparent",
      boxShadow: "none",
      overflow: "visible"
    },
    searchIcon: {
      color: "rgba(0, 0, 0, 0.23)"
    },
    imgWrap: {
      height: 100,
      overflow: 'hidden',
      borderRadius: 8,
      boxShadow: '0 0 10px 0px #ccc',
      marginRight: 20,
      marginBottom: 20,
      maxWidth: 125,
      position: 'relative'
    },
    galleryWrap: {
      display: 'flex'
    },
    uploadLabel: {
      backgroundColor: tinycolor(theme.palette.primary.main),
      color: '#f4f4f4',
      maxWidth: 220,
      display: 'inline-block',
      borderRadius: 8,
      textAlign: 'center',
      padding: '8px 12px',
      margin: '20px 0'
    },
    deleteImageX: {
      fontSize: 20,
      position: 'absolute',
      top: 5,
      left: 5,
      cursor: 'pointer',
      lineHeight: .5
    },
    formDisplay: {
      padding: '20px 0',
      display: 'flex',
      flexDirection: 'column',
      margin: '0 auto',
      right: 0,
    },
    tabContent: {
      marginTop: '20px'
    },
    autocomplete: {
      width: '100%',
      margin: '0 auto',
      padding: '20px 0'
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    error: {
      color: '#f44336 !important',
      borderColor: '#f44336 !important',
    },
    bottomMenu: {
      padding: '20px 4px 0 16px'
    },
    stepper: {
      padding: 0
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
    searchRow: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      '& > div': {
        flex: '1 1 0px',
        minWidth: '250px'
      },
      paddingBottom: '10px',
      alignItems: 'top'
    },
    notificationComponent: {
      paddingRight: theme.spacing(4),
    },
    bold: {
      fontWeight: 'bold'
    },
    twoColWrapper: {
      display: 'grid',
      gridTemplateColumns: '20% 80%',
      gridGap: '10px',
    },
    gridCol: {
      padding: '2px'
    },
    to: {
      minWidth: '100px',
      marginLeft: '10px'
    },
    from: {
      minWidth: '100px',
    },
    'div[class^="MUIDataTableFilter-root"]': {
      width: '800px'
    },
    saveBookJobButton: {
      color: 'black',
      "&:hover, &:focus": {
        backgroundColor: theme.palette.lightHighlight.default,
      }
    },
    calendarFocused: {
      '& label': {
        color: theme.palette.tt.main,
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: theme.palette.tt.main,
        },
        '&:hover fieldset': {
          borderColor: theme.palette.tt.main,
          borderWidth: '2px'
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.tt.main,
        },
      },
    },
    inline: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        '& > div': {
          flex: '1 1 0px',
          minWidth: '250px',
        },
        paddingBottom: '10px'
    },
    inlineSmallBig: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        '& > div': {
          flex: '1 1 0px',
          minWidth: '250px',
        },
        paddingBottom: '10px'
    },
    cancelButton: {
        background: 'transparent'
    },
    retestsCalendars: {
      '& > *': {
          minWidth: '150px',
          paddingBottom: '10px'
      },
      '& > :first-child': {
        marginRight: '10px'
      }
    },
    strike: {
        position: 'relative',
        padding: '0 10px',
        margin: '10px',

        '&:after' : {
          content: '" "',
          position: 'absolute',
          border: '1px solid #999',
          top: '50%',
          marginTop: '-1px',
          width: '100%',
          left: '-2px'
        }

    },
    selectedBorder : {
        border: '1px solid rgb(57,118,203)',
    },
    selectedBackgroundColour: {
        backgroundColor: 'rgba(25, 118, 210, 0.08)'
    },
    noPadding: {
        padding: 0,
    },
    done: {
        backgroundColor: 'rgb(146,186,77, 0.6)',
    },
    inProgress: {
        backgroundColor: 'rgb(66,108,193, 0.6)',
    },
    actionRequired: {
        backgroundColor: 'rgb(171,46,43, 0.6)',
    },
    onhold: {
        backgroundColor: 'rgb(186,154,70, 0.6)',
    },
    archived: {
        backgroundColor: 'rgb(164,164,164, 0.6)',
    },
    doneText: {
        color: 'rgb(146,186,77)',
    },
    inProgressText: {
        color: 'rgb(66,108,193)',
    },
    actionRequiredText: {
        color: 'rgb(171,46,43)',
    },
    onholdText: {
        color: 'rgb(186,154,70)',
    },
    archivedText: {
        color: 'rgb(164,164,164)',
    },
    archivedTextStrikeThrough: {
        textDecoration: 'line-through'
    },
    assetType: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        '& > div': {
          flex: '1 1 0px',
          minWidth: '250px',
        },
    },

    /*tableDataStrike: {
      position: 'relative',
      '&:before': {
        content: '" "',
        position: 'absolute',
        top: '50%',
        left: 0,
        borderBottom: '1px solid #999',
        width: '100%'
      }
    }*/
}))
